import React from 'react';
import { Accordion, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function Accordions() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>آکاردئون</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/accordion'>آکاردئون</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col className='mb-4' md={12} lg={6}>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                آکاردئون معمولی
                            </div>

                            <Card.Body>
                                <Accordion defaultActiveKey='0'>
                                    <Accordion.Item eventKey='0'>
                                        <Accordion.Header>
                                            آکاردئون اول
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            <strong>
                                                این اولین آیتم آکاردئون است که
                                                به صورت پیش فرض باز است.
                                            </strong>{' '}
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='1'>
                                        <Accordion.Header>
                                            آکاردئون دوم
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey='2'>
                                        <Accordion.Header>
                                            آکاردئون سوم
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={12} lg={6}>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                آکاردئون بدون خط
                            </div>

                            <Card.Body>
                                <Accordion defaultActiveKey='0' flush>
                                    <Accordion.Item eventKey='0'>
                                        <Accordion.Header>
                                            آکاردئون اول
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            <strong>
                                                این اولین آیتم آکاردئون است که
                                                به صورت پیش فرض باز است.
                                            </strong>{' '}
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey='1'>
                                        <Accordion.Header>
                                            آکاردئون دوم
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey='2'>
                                        <Accordion.Header>
                                            آکاردئون سوم
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            لورم ایپسوم متن ساختگی با تولید
                                            سادگی نامفهوم از صنعت چاپ، و با
                                            استفاده از طراحان گرافیک است،
                                            چاپگرها و متون بلکه روزنامه و مجله
                                            در ستون و سطرآنچنان که لازم است، و
                                            برای شرایط فعلی تکنولوژی مورد نیاز،
                                            و کاربردهای متنوع با هدف بهبود
                                            ابزارهای کاربردی می باشد، کتابهای
                                            زیادی در شصت و سه درصد گذشته حال و
                                            آینده، شناخت فراوان جامعه و متخصصان
                                            را می طلبد، تا با نرم افزارها شناخت
                                            بیشتری را برای طراحان رایانه ای علی
                                            الخصوص طراحان خلاقی، و فرهنگ پیشرو
                                            در زبان فارسی ایجاد کرد، در این صورت
                                            می توان امید داشت که تمام و دشواری
                                            موجود در ارائه راهکارها، و شرایط سخت
                                            تایپ به پایان رسد و زمان مورد نیاز
                                            شامل حروفچینی دستاوردهای اصلی، و
                                            جوابگوی سوالات پیوسته اهل دنیای
                                            موجود طراحی اساسا مورد استفاده قرار
                                            گیرد.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
